<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="test-responses"
            dusk="test-responses-table"
            :items="testResponsesIn"
            :fields="fields"
            :show-empty="true">
            <template v-slot:cell(progress)="data">
                <b-progress
                    class="w-75"
                    v-if="data.item.is_submitted || data.item.answers_count > 0">
                    <b-progress-bar
                        v-b-tooltip.hover
                        :value="
                            data.item.is_submitted
                                ? data.item.test_issuing.test.questions_count
                                : data.item.answers_count
                        "
                        :max="data.item.test_issuing.test.questions_count"
                        title="Voltooide vragen"
                        :variant="data.item.is_submitted ? 'success' : 'warning'">
                        {{
                            data.item.is_submitted
                                ? data.item.test_issuing.test.questions_count
                                : data.item.answers_count
                        }}
                        / {{ data.item.test_issuing.test.questions_count }}
                    </b-progress-bar>
                </b-progress>
                <span
                    class="mx-auto text-muted"
                    v-else>
                    {{ $t('testcenter.not_yet_started') }}
                </span>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="management-actions actions">
                    <b-button
                        class="btn-open"
                        :v-b-tooltip="$t('common.open')"
                        variant="primary-icon-only"
                        @click="getTestLink(data.item)">
                    </b-button>
                </div>
            </template>

            <template #empty>
                <div class="not-found with-header empty-tests-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('testcenter.no_tests_found') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

export default {
    name: 'design-2021-student-test-center-component',
    components: { Design2021ApprenticeDataTable },
    props: {
        testResponsesIn: {
            type: Array,
            required: true,
            default: [],
        },
    },
    data() {
        return {
            fields: [
                {
                    key: 'test_issuing.test.title',
                    label: this.$t('common.name'),
                },
                {
                    key: 'progress',
                    label: this.$t('testcenter.progress'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        getTestLink(testResponse) {
            window.location.href = this.routes.testResponse(testResponse.id);
        },
    },
};
</script>

<style scoped lang="scss"></style>
